import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/en';
import nl from '@/locales/nl';

const storageKey = 'employee-portal-language';
const storedLanguage = localStorage.getItem(storageKey);
const initialLanguage = storedLanguage === 'en' || storedLanguage === 'nl' ? storedLanguage : 'nl';

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    nl: { translation: nl },
  },
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem(storageKey, lng);
});

export default i18n;
